export enum EnumConversationState {
  Idle = 'idle',
  Processing = 'processing',
  WaitingHitl = 'waiting_hitl',
  Error = 'error',
  Archived = 'archived'
}

/** Um estado que o front não conhece não vira nada: a lista mantém o atual. */
export const toConversationState = (
  raw: unknown
): EnumConversationState | null =>
  Object.values(EnumConversationState).find((state) => state === raw) ?? null;
